<div style="margin: 1em;">
  <div class="has-text-centered">{{Title}}</div>
  @if (ChartType == 'line') {
    <canvas baseChart
      [height]="Height"
      [data]="ChartData"
      [options]="ChartOptions"
      [type]="'line'">
    </canvas>
  }
  @if (ChartType == 'bar') {
    <canvas baseChart
      [height]="Height"
      [data]="ChartData"
      [options]="ChartOptions"
      [type]="'bar'">
    </canvas>
  }
</div>